<template>
  <TableComp
    v-if="upgradeGroups"
    :name="$t('global.upgrades')"
    :headers="headers"
    :status="status"
    :number-of-items="upgradeGroups.length"
    empty-image="upgrades"
    :empty-bold-message="$t('global.no-upgrades-bold-message')"
    empty-message=" "
    :empty-sub-message="$t('global.no-upgrades-message')"
    v-on:update:list="updateList"
  >
    <template #desktop>
      <PluginUpgradeRow
        v-for="(group, index) in upgradeGroups"
        :upgrade-group="group"
        :site="site"
        v-bind:key="index"
      />
    </template>
  </TableComp>
</template>

<script>
import PluginUpgradeRow from "@/components/display/table/PluginUpgradeRow";
import store from "@/store";
import TableComp from "@/components/display/table/TableComp";

export default {
  name: "PluginUpgradesTable",
  props: {
    upgradeGroups: Array,
    status: Object,
    site: Object,
  },
  components: {
    TableComp,
    PluginUpgradeRow,
  },
  setup(props) {
    const headers = [];

    const updateList = () => {
      store.dispatch("visualComparison/getUpgradeGroupList", props.site.id);
    };

    return {
      headers,
      updateList,
    };
  },
};
</script>
